import { apiUrls } from "../../config/apiUrls";
import { IApiServiceResponse } from "../../types/api";
import basicRequest from "../basicRequest";

export type BusinessProfilePostData = {
    city: string;
    line: string;
    name: string;
    vatnr: string | null;
    taxcode: string | null;
    zipcode: string;
    email: string | null;
    variationeffectivedate: string | null;
    selfacceptance?: boolean;
    modifyselfacceptance?: boolean;
}

export const profileService = {
    getProfile: async (): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        if (window.location.pathname.startsWith("/fleet-and-route")) {
            // Blocca la chiamata su FleetAndRoute
            return { success: false, responseBody: null, statusCode: 200, errorMessage: null };
        }
        return await request.get(apiUrls.getProfile);
    },
    modifyProfile: async (data: {
        phone: string,
        role: number,
        privacyConsent: boolean,
        marketingConsent: boolean,
        collaborationConsent: boolean
    }): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.post(apiUrls.postProfile, data);
    },
    getBusinessProfile: async (): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.get(apiUrls.getBusinessProfile);
    },
    modifyBusinessProfile: async (data: BusinessProfilePostData): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.post(apiUrls.postBusinessProfile, data);
    },
}